import { InjectionToken } from '@angular/core';
import { ComponentType } from '@angular/cdk/portal';

export const PUPIL_PROFILE_MODAL: InjectionToken<ComponentType<unknown>> =
  new InjectionToken<ComponentType<unknown>>('PUPIL_PROFILE_MODAL');

export const PUPIL_CONTACT_MODAL: InjectionToken<ComponentType<unknown>> =
  new InjectionToken<ComponentType<unknown>>('PUPIL_CONTACT_MODAL');

export const PUPIL_SCHOOL_MODAL: InjectionToken<ComponentType<unknown>> =
  new InjectionToken<ComponentType<unknown>>('PUPIL_SCHOOL_MODAL');

export const PUPIL_COURSES_MODAL: InjectionToken<ComponentType<unknown>> =
  new InjectionToken<ComponentType<unknown>>('PUPIL_COURSES_MODAL');
